import React, { useState, useEffect } from "react";
import {
  createTheme,
  ThemeProvider,
  CssBaseline,
  Paper,
  Button,
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GetCustodianTable } from "../../redux/Actions/userStatusService";
import Loader from "../../Loader";
import HeaderIcon from "../../Images/headericon.png";
import AddCustodian from "../../Modals/CustodianModals/AddCustodian";
import EditCustodian from "../../Modals/CustodianModals/EditCustodian";

const theme = createTheme();

const Index = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [Editopen, setEditOpen] = useState(false);
  const [custData, setCustData] = useState();
  const { custodianData, loading } = useSelector((state) => state.userStatus);

  useEffect(() => {
    dispatch(GetCustodianTable());
  }, [dispatch]);

  const handleEdit = (values) => {
    setCustData(values);
    setEditOpen(true);
  };

  const handleAddAsset = (id) => {
    navigate(`/assets/${id}`);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Paper
        sx={{ p: 2, display: "flex", flexDirection: "column" }}
        elevation={0}
      >
        <div className="row rows" style={{ marginLeft: "2px" }}>
          <div className="col-1">
            <img src={HeaderIcon} alt="Header Icon" width="45" height="45" />
          </div>
          <div
            className="col-9"
            style={{ marginTop: "10px"}}
          >
            <Typography variant="h6" style={{ color: "#18275A" }}>
              All Custodians
            </Typography>
          </div>
          <div className="col-2" style={{ marginTop: "10px", marginBottom: "-50px" }}>
            {/* <Button
              variant="contained"
              disableElevation
              onClick={() => setOpen(true)}
              sx={{
                marginLeft: 3,
                textTransform: "none",
                backgroundColor: "#1976D2",
                color: "#FFFFFF",
                "&:hover": {
                  backgroundColor: "#1565C0",
                },
              }}
            >
              Add Custodian
            </Button> */}
          </div>
        </div>
      </Paper>
      {loading ? (
        <Loader />
      ) : (
        <Container
          maxWidth="lg"
          component="main"
          sx={{ ml: -3, pl: 0 }}
        >
          {Object.keys(custodianData || {}).length === 0 ? (
            <Typography
              variant="h6"
              sx={{ textAlign: "center", mt: 2 }}
            >
              Sorry, no data exists.
            </Typography>
          ) : (
            <Grid container spacing={5}>
              {Object.entries(custodianData || {}).map(([key, value]) => (
                <Grid item key={key} xs={12} sm={6} md={3} lg={3}>
                  <Card
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      height: "200px",
                      padding: 1,
                      cursor: "pointer",
                      marginTop: "20px"
                    }}
                    onClick={() => handleEdit({ name: key, ...value })}
                  >
                    <CardContent
                      sx={{
                        flexGrow: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={value.logo}
                        alt={key}
                        style={{ height: "70px", width: "70px" }}
                      />
                      <Typography variant="h6" sx={{ mt: 1, fontSize: 16, fontWeight: "bold" }}>
                        {value.name}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          )}
        </Container>
      )}
      {/* <AddCustodian open={open} setOpen={setOpen} /> */}
      {/* <EditCustodian open={Editopen} setOpen={setEditOpen} custData={custData} /> */}
    </ThemeProvider>
  );
};

export default Index;
